/**
 * Estrae un messaggio di errore leggibile da una axios error.
 *
 * FastAPI/Pydantic restituisce `detail` in tre forme diverse:
 *  - stringa (HTTPException con detail="...")
 *  - array di oggetti `{type, loc, msg, input, ctx, url}` (validation 422)
 *  - oggetto singolo (raro)
 *
 * Renderizzare l'oggetto direttamente in `toast.error()` o nel JSX scatena
 * "Minified React error #31: Objects are not valid as a React child".
 * Questo helper appiattisce SEMPRE a stringa.
 *
 * @param {object} e - axios error (con e.response.data.detail)
 * @param {string} [fallback="Errore"] - messaggio di default se nulla è disponibile
 * @returns {string}
 */
export const errMsg = (e, fallback = "Errore") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    return d.map((it) => {
      if (typeof it === "string") return it;
      const loc = Array.isArray(it?.loc) ? it.loc.slice(-1)[0] : "";
      const msg = it?.msg || "Validation error";
      return loc ? `${loc}: ${msg}` : msg;
    }).join(" · ");
  }
  if (d && typeof d === "object") return d.msg || JSON.stringify(d);
  return e?.message || fallback;
};
